import ArrowBack from "@mui/icons-material/ArrowBackIosNew";
import ArrowForward from "@mui/icons-material/ArrowForwardIos";
import { Stack, IconButton, styled } from "@mui/material";

export interface PaginatorProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (direction: -1 | 1) => void;
}

interface PageTextProps {
  active?: boolean;
}

const PageText = styled("span", {
  shouldForwardProp: (prop: any) => prop != "active",
})<PageTextProps>(({ theme, active }) => ({
  display: "inline-block",
  fontSize: "0.75rem",
  lineHeight: 24 / 12,
  color: theme.palette.shades.neutral[active ? 600 : 400],
  fontWeight: active ? 500 : 400,
  minWidth: "8px",
  whiteSpace: "nowrap",
}));

const Paginator = ({
  currentPage,
  totalPages,
  onPageChange,
}: PaginatorProps) => {
  const disablePreviousPage = currentPage < 2;
  const disableNextPage = currentPage === totalPages;

  return (
    <Stack direction="row" alignItems="center" spacing="6px">
      <IconButton
        sx={{ width: "18px", height: "18px", color: "shades.neutral.600" }}
        onClick={() => onPageChange(-1)}
        disabled={disablePreviousPage}
      >
        <ArrowBack sx={{ height: "10px", color: "shades.neutral.600" }} />
      </IconButton>
      <PageText>
        <PageText active={currentPage !== 0}>{currentPage}</PageText> of{" "}
        {totalPages}
      </PageText>
      <IconButton
        sx={{ width: "18px", height: "18px" }}
        onClick={() => onPageChange(1)}
        disabled={disableNextPage}
      >
        <ArrowForward sx={{ height: "10px", color: "shades.neutral.600" }} />
      </IconButton>
    </Stack>
  );
};

export default Paginator;
